/* DISPATCHER */
import { AppDispatcher } from 'dispatcher';
/* CONSTANTS */
import * as constants from 'vd-constants';

export default {
  handleEventHoverActions(payload) {
    AppDispatcher.dispatch(constants.EVENT_ITEM_HOVER, {
      payload,
    });
  },
};
